import React, { useEffect, useState } from "react";
import {
  Breadcrumb,
  Button,
  Card,
  Col,
  Container,
  OverlayTrigger,
  Row,
} from "react-bootstrap";
import Questionicon from "../../Assets/icons/antOutline-question-circle.png";
import { useNavigate, useParams } from "react-router-dom";
import { apiBaseURL } from "../../Common/ApiHelper";
import axios from "axios";

const AccountArea = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [revaledAPIData, setRevealedAPIData] = useState(false);
  const [fetchKeyData, setFetchKeyData] = useState([]);
  const user = JSON.parse(localStorage.getItem("userData"));
  const popover = (
    <div className="pop_over blue_text d-flex  align-items-center mt-4 mb-5">
      <img src={Questionicon} alt="icon" className="mx-3" />
      <b className="py-2">
        Refunds Will No Longer Be Accepted For This Purchase Once Key Is
        Revealed.
      </b>
    </div>
  );
  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios({
        method: "get",
        url: `${apiBaseURL}user/getOrderHistoryById?orderId=${id}`,
      });
      if (response?.status === 200) {
        setData([response.data.data]);
        setRevealedAPIData(response.data.data.myAccountDetails.isClicked);
        setLoading(false);
      }
    } catch (e) {
      console.log("error", e);
      setLoading(false);
    }
  };

  const fetchKey = async () => {
    setLoading(true);
    try {
      const response = await axios({
        method: "put",
        url: `${apiBaseURL}user/isRevealed`,
        data: {
          email: user.email,
          id: data[0]?.myAccountDetails?._id,
        },
      });
      if (response?.status === 200) {
        setFetchKeyData(response?.data?.data);
        setRevealedAPIData(response?.data?.data?.isClicked);
        setLoading(false);
      }
    } catch (e) {
      console.log("error", e);
    }
  };
  useEffect(() => {
    if (revaledAPIData) {
      fetchKey();
    }
  }, [data]);
  useEffect(() => {
    fetchData();
  }, []);
  const downloadMedia = (file) => {
    window.open(file);
  };
  const handleDate = (dateString) => {
    const date = new Date(dateString);

    const year = date.getUTCFullYear();
    const month = date.getUTCMonth() + 1; // months are zero-indexed
    const day = date.getUTCDate();

    const formattedDate = `${year}/${month.toString().padStart(2, "0")}/${day
      .toString()
      .padStart(2, "0")}`;

    return formattedDate;
  };
  return (
    <>
      <div className="main">
        <Container className="py-5 px-1">
          <Breadcrumb>
            <Breadcrumb.Item>
              <small
                className="BreadCrumbs_style"
                onClick={() => navigate("/")}
              >
                Home
              </small>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <small
                className="BreadCrumbs_style"
                onClick={() => navigate("/category/MicrosoftOffice")}
              >
                Shop
              </small>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <small className="BreadCrumbs_style">Account</small>
            </Breadcrumb.Item>
          </Breadcrumb>

          <Row>
            <Col md={3} xl={3}>
              <div className="d-grid gap-2 pb-4 Account_card_div">
                <div className="Account_btns Account_cards align_center">
                  <h6 className="my-4 mx-3">
                    <b>
                      Welcome back, <br />{" "}
                      {user?.firstName + " " + user?.lastName}
                    </b>
                  </h6>
                </div>
              </div>
              <div className="d-grid gap-2 pb-3 Account_card_div">
                <div className="Account_btns Account_cards p-4 align_center">
                  <h6 className="pt-2 ">
                    <b>Have Questions?</b>
                  </h6>
                  <p className="text_muted">
                    Call (833) 465 0300 <br /> or contact us via chat.
                  </p>
                </div>
              </div>
            </Col>
            <Col md={9} xl={9}>
              <Card className="Account_Main_Card box_shadow">
                <Card.Header className="blue_bg Account_Card_Header ">
                  <Container>
                    <Row>
                      <Col className="Header_Text ps-5 ">
                        <b>Past Orders</b>
                      </Col>
                    </Row>
                  </Container>
                </Card.Header>
                {loading ? (
                  <div class="d-flex justify-content-center">
                    <span
                      class="spinner-border spinner-border-lm me-3 m-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  </div>
                ) : (
                  <Card.Body className="py-5">
                    {data.map((items) => {
                      return (
                        <div className="d-flex justify-content-between Account_ListDiv">
                          <ul className="Card_ULlist">
                            <li className="Card_list text_muted Card_LargeText">
                              <b>
                                Order #{items?.orderId} | Date :{" "}
                                {handleDate(items?.createdAt || "")}
                              </b>
                            </li>
                            {items.cartInfo[0].cartData.map((product) => {
                              return (
                                <li className="Card_list text_muted">
                                  {product.name} x {product.quantity}
                                </li>
                              );
                            })}

                            <li className="Card_list text_muted">Sales Tax:</li>
                            <li className="Card_list text_muted">
                              <b>Applied Coupon:</b>
                            </li>
                            <li className="Card_list text_muted">
                              <b>Subtotal:</b>
                            </li>
                          </ul>
                          <ul className="Card_ULlist d-flex flex-column align-items-end">
                            <li className="Card_list text_muted Card_LargeText">
                              <b>Totals</b>
                            </li>
                            {items.cartInfo[0].cartData.map((product) => {
                              return (
                                <li className="Card_list text_muted">
                                  ${product?.salePrice}USD
                                </li>
                              );
                            })}

                            <li className="Card_list text_muted ">9%</li>
                            <li className="Card_list  text_muted">
                              <b>
                                {items?.coupon === null ? "-" : items?.coupon}
                              </b>
                            </li>
                            <li className="Card_list  text_muted">
                              <b>${items?.payAmount} USD </b>
                            </li>
                          </ul>
                        </div>
                      );
                    })}

                    <div className="p-4 my-1">
                      <Row>
                        <Col xxl={6}>
                          <div className="d-grid gap-2 pb-4">
                            <h6 className="Account_Btn_head">
                              <b>Download Media</b>
                            </h6>
                            {data[0]?.cartInfo[0]?.cartData.map((items) => {
                              return (
                                <>
                                  {items.subCategoryName === "Windows 7" ? (
                                    <>
                                      <Button
                                        size="lg"
                                        className="Account_btns blue_text Account_Card_btn"
                                        onClick={() =>
                                          downloadMedia(
                                            items.downloadLink.Download32
                                          )
                                        }
                                      >
                                        <b className="px-4">
                                          Download {items.name} - 32 Bit
                                        </b>
                                      </Button>
                                      <Button
                                        size="lg"
                                        className="Account_btns blue_text Account_Card_btn"
                                        onClick={() =>
                                          downloadMedia(
                                            items.downloadLink.Download64
                                          )
                                        }
                                      >
                                        <b className="px-4">
                                          Download {items.name} - 64 Bit
                                        </b>
                                      </Button>
                                    </>
                                  ) : (
                                    <Button
                                      size="lg"
                                      className="Account_btns blue_text Account_Card_btn"
                                      onClick={() =>
                                        downloadMedia(
                                          items.downloadLink.preview ||
                                            items.downloadLink.Download
                                        )
                                      }
                                    >
                                      <b className="px-4">
                                        Download {items.name}
                                      </b>
                                    </Button>
                                  )}
                                </>
                              );
                            })}
                          </div>
                        </Col>
                        <Col xxl={6}>
                          <div className="d-grid gap-2 pb-4">
                            <h6 className="Account_Btn_head">
                              <b>Installation Guide</b>
                            </h6>

                            {data[0]?.cartInfo[0]?.cartData.map((items) => {
                              return (
                                <Button
                                  size="lg"
                                  className="Account_btns blue_text Account_Card_btn"
                                >
                                  <b className="px-4">
                                    N/A - Please contact support for assistance.
                                  </b>
                                </Button>
                              );
                            })}
                          </div>
                        </Col>
                        {revaledAPIData ? (
                          fetchKeyData?.cart?.map((items, index) => {
                            console.log("items", items);
                            return (
                              <div className="d-flex justify-content-between Account_ListDiv">
                                <ul className="Card_ULlist">
                                  <li className="Card_list text_muted Card_LargeText">
                                    <b>{index + 1}. Product</b>
                                  </li>
                                  <li className="Card_list text_muted">
                                    {items?.name}
                                  </li>
                                </ul>
                                <ul className="Card_ULlist d-flex flex-column align-items-end">
                                  <li className="Card_list text_muted Card_LargeText">
                                    <b>Activation Key</b>
                                  </li>
                                  {items?.activationKey?.map((item) => {
                                    return (
                                      <li className="Card_list text_muted">
                                        {item ? (
                                          item
                                        ) : (
                                          <>
                                            Auto-Assign Failed. Please allow 1-2
                                            hours <br /> for manual entry or
                                            contact support via chat.
                                          </>
                                        )}
                                      </li>
                                    );
                                  })}
                                </ul>
                              </div>
                            );
                          })
                        ) : (
                          <Col xxl={6}>
                            <div className="d-grid pb-3">
                              <h6 className="Account_Btn_head">
                                <b>Your Product Keys</b>
                              </h6>
                              <OverlayTrigger
                                trigger="hover"
                                placement="bottom"
                                overlay={popover}
                                className="myaccount_tooltip"
                              >
                                <Button
                                  size="lg"
                                  className="Account_btns blue_text Account_Card_btn hover_btn"
                                  onClick={() => fetchKey()}
                                >
                                  <img
                                    src={Questionicon}
                                    alt="icon"
                                    className="popover_img ms-4"
                                  />

                                  <b className="px-3">
                                    Click To Reveal Activation Key
                                  </b>
                                </Button>
                              </OverlayTrigger>
                            </div>
                          </Col>
                        )}
                      </Row>
                    </div>
                  </Card.Body>
                )}
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default AccountArea;
